
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/members/community/my-study-group",
      function () {
        return require("private-next-pages/members/community/my-study-group/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/members/community/my-study-group"])
      });
    }
  